import * as React from 'react';
import NotificationCell from './notificationCell';
import Date from '../../WorkkardDetail/MiddlePanelContainer/getDate';

export default class NotificationGroup extends React.Component {
    constructor(props){
        super(props);
    }


    render() {
        const { data, extraData } = this.props;
        return (
            <div className="combinedListingGroup detailListingGroup">

               {data &&  <h4 className="sticky mb"><Date inputDate={data} /></h4>}
                {data.data.map((d) => {
                    if (extraData.IsGroupByEnabled && !extraData.showGroupedNotificationDetail)
                        return <React.Fragment key={d.id}><NotificationCell data={d.data[extraData.key]} extraData={Object.assign({},extraData,d.data)} onCellClick={this.props.onCellClick}/></React.Fragment>
                    return <React.Fragment key={d.id}><NotificationCell data={d.data} extraData={extraData} onCellClick={this.props.onCellClick}/></React.Fragment>
                })}
            </div>
        );
    }
}